<div class="optionalInputs" *ngIf="category.optionalInputs?.length">
    <formio-loader></formio-loader>

    <div *ngIf="category?.isDescriptionStandardRequired" class="{{viewOnly ? 'readOnlyEditor' : ''}}">
        <label class="field-required title">{{'forms.common.Description Standard' | translate}}</label>
        <p-editor name="questionNotes" [style]="{'height':'320px'}" required
            [(ngModel)]="category.descriptionStandardResult" [readonly]="viewOnly">
        </p-editor>
    </div>
    <br />
    <div class="col-sm-12" *ngIf="category?.hasAttachments">
        
        <!-- <div class="wrapFlex align-center" *ngIf="category.attachmentsTooltip">
            <i class="fas fa-info-circle iconTooltip"></i>
            <span class="hint">{{category.attachmentsTooltip}}</span>
            
        </div> -->

        <ng-container *ngFor="let item of category.attachments">
            <div >
                <div>
                    <i class="fas fa-info-circle iconTooltip" *ngIf="item.attachmentTooltipAr"
                        [pTooltip]="item.attachmentTooltipAr"></i>
                    <label class="label" [class.field-required]="item.attachmentIsRequired">
                        {{item.attachmentNameEn | translate}}
                        {{item.name | translate}}
                    </label>
                    
                </div>
                <div *ngIf="category.originKey=='test'">
                    <formio style="margin-top: -20px;" #forms [submission]="{data:{attachments : item.data }}"
                        formKey="instwizardextssrqaattachments" [showLoader]="false" (formLoad)="formLoad($event)"
                        [readOnly]="viewOnly || category.notApply" [viewOnly]="viewOnly || category.notApply" >
                    </formio>
                </div>
                <div *ngIf="category.originKey!='test'">
                    <formio style="margin-top: -20px;" #forms [submission]="{data:{attachments : item.data }}"
                    formKey="indicatorattachments" [showLoader]="false" (formLoad)="formLoad($event)"
                    [readOnly]="viewOnly || category.notApply" [viewOnly]="viewOnly || category.notApply">
                    </formio>
                </div>
                <!-- <formio style="margin-top: -20px;" #forms [submission]="{data:{attachments : item.data }}"
                    formKey="indicatorattachments" [showLoader]="false" (formLoad)="formLoad($event)"
                    [readOnly]="viewOnly || category.notApply" [viewOnly]="viewOnly || category.notApply">
                </formio> -->
                
                <!-- <formio style="margin-top: -20px;" #forms [id]="domain.id" [submission]="{data:{attachments : domain.attachmentsInstance }}"
                [formKey]="data.indicator.attachmentsFormKey" [showLoader]="false" (formLoad)="formLoad($event)"
                [readOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed"
                [viewOnly]="data.options.disableAttachments || domain.decision == indicatorStatus.Completed">
            </formio> -->
            </div>
            <br />
        </ng-container>
    </div>
    <div class="col-sm-12" *ngIf="category?.hasPledgeAndAcknowledgment">
        <br />
        <ng-container *ngIf="category.pledgeTooltip">
            <i class="fas fa-info-circle iconTooltip"></i>
            <label>{{category.pledgeTooltip}}</label>
            <br />
        </ng-container>
        <span *ngIf="category.pledgeIsRequired" class="red">*</span>
        <input type="checkbox" id="pledge_{{category._id}}" name="pledge_{{category._id}}"
            [(ngModel)]="category.pledgeValue" [required]="category.pledgeIsRequired"
            [disabled]="viewOnly || category.notApply">
        &nbsp;
        <label for="pledge_{{category._id}}" [innerHTML]="category.pledgeName">
        </label>
    </div>
    <br />
    <div class="form-custom-warning" *ngIf="!isOptionalInputsValid">
        {{'forms.common.At least one item must be added to each of the following' | translate}}
    </div>

    <ol *ngIf="category">
        <li *ngFor="let optionalInput of category.optionalInputs;let last = last"
            [ngStyle]="{'margin-bottom' : last? '0' : '10px'}">
            <div class="action-row">
                <span class="title">{{optionalInput.name}}</span>
                <button class="add" *ngIf="!viewOnly" (click)="addOptionalInput(optionalInput)">
                    <i class="fa fa-plus"></i>
                </button>
            </div>
            <div class="row" *ngFor="let item of optionalInput.results;let i = index" style="margin-bottom: 5px;">
                <div class="col-sm-10">
                    {{i + 1}} - <input type="text" id="{{optionalInput?.value}}-{{i}}"
                        name="{{optionalInput.value}}-{{i}}" [(ngModel)]="item.value" [disabled]="viewOnly"
                        (change)="changeValue(optionalInput)" />
                </div>
                <div class="col-sm-2">
                    <i class="fa fa-trash delete" *ngIf="!viewOnly" (click)="removeOptionalInput(optionalInput,i)"></i>
                </div>
            </div>
        </li>
    </ol>

    <br />
    <div [style.textAlign]="'end'" *ngIf="!viewOnly">
        <button type="button" class="dialog-button dialog-save" (click)="saveCategory()"
        [disabled]="!category.attachmentsValid || !isDescriptionStandardResultValid || !isPledgeResultValid || category.hasError">
            {{'forms.common.Save' |translate}}</button>
    </div>